module.exports = __webpack_public_path__ + "img/product_all_active.fdb0c8c3.svg";